export class ControlKeys {
    controlId: number;
    controlType: string;
    rateKey: number;
    effectiveDate: any;
    expiryDate: any;
    releasePending: any;
    releaseDate: any;
    filingType: string;
    updateProgram: string;
    updateId: number;
    updateDate: any;
    cycleName: any;
    createdDate: any;
}

export class ControlKeysFrt{
    controlId: number;
    controlType: string;
    cycleName: any;
    rateKey: number;
    effectiveDate: any;
    expiryDate: any;
    releasePending: any;
    releaseDate: any;
    filingType: string;
    dateBidCycleOpen: any;
    dateBidCycleClose: any;
    dateEffectiveOpen: any;
    dateEffectiveClose: any;
    updateProgram: string;
    updateId: number;
    updateDate: any; 
}